import React from 'react';
import { Grid, Paper, Typography, Box } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

export const OnboardingHeaderSummary = ({ headerSummary }) => {
    const classes = commonStyle();

    const getBgColor = (className) => {
        if (className === classes.Success_h3) return '#90EE90';
        if (className === classes.total_h3) return '#1d531dff';
        if (className === classes.Fail_h3) return '#ffebee';
        if (className === classes.Pending_h3) return '#fffde7';
        return '#f5f5f5'; 
    };

    const SummaryItem = ({ label, value, className }) => (
        <Paper
            elevation={3}
            style={{
                backgroundColor: getBgColor(className),
                padding: 16,
                margin: 8,
                minWidth: 180,
                textAlign: 'center',
                flex: '1 1 200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', // vertical center
            }}
        >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    {label}
                </Typography>
                <Typography variant="h6" className={className}>
                    {value || 0}
                </Typography>
            </Box>
        </Paper>
    );

    if (!headerSummary) return null;

    return (
        <Box component={Paper} style={{ padding: 16, marginBottom: 16 }}>
            <Box display="flex" flexWrap="wrap" justifyContent="space-around">
                <SummaryItem
                    label="Total Agents"
                    value={headerSummary.TotalRecords}
                    className={classes.total_h3}
                />
                <SummaryItem
                    label="Success"
                    value={headerSummary.SuccessBankStatus}
                    className={classes.Success_h3}
                />
                <SummaryItem
                    label="Failed"
                    value={headerSummary.FailedBankStatus}
                    className={classes.Fail_h3}
                />
                <SummaryItem
                    label="Success with Terminal ID & Merchant ID"
                    value={headerSummary.SuccessWithTerminalMerchant}
                    className={classes.Success_h3}
                />
                <SummaryItem
                    label="Success without Terminal ID & Merchant ID"
                    value={headerSummary.SuccessWithoutTerminalMerchant}
                    className={classes.Pending_h3}
                />
                <SummaryItem
                    label="Rejected"
                    value={headerSummary.RejectedStatus}
                    className={classes.Fail_h3}
                />
                <SummaryItem
                    label="Process"
                    value={headerSummary.Process}
                    className={classes.Pending_h3}
                />
            </Box>
        </Box>
    );
};
